export function moveDepartment<T extends { id: string }>(
	departments: T[],
	draggedDepartmentId: string,
	targetDepartmentId: string,
): T[] {
	const draggedIndex = departments.findIndex(
		(department) => department.id === draggedDepartmentId,
	);
	const targetIndex = departments.findIndex((department) => department.id === targetDepartmentId);
	if (draggedIndex < 0 || targetIndex < 0 || draggedIndex === targetIndex) {
		return departments;
	}

	const reordered = [...departments];
	const [draggedDepartment] = reordered.splice(draggedIndex, 1);
	reordered.splice(targetIndex, 0, draggedDepartment!);
	return reordered;
}

export function departmentOrderChanged(before: { id: string }[], after: { id: string }[]): boolean {
	return before.some((department, index) => department.id !== after[index]?.id);
}
